var exports = {
  "Vg": "ChatSkeleton.module__grid___dUMxa1",
  "wx": "ChatSkeleton.module__header___dUMxa1",
  "D_": "ChatSkeleton.module__identity___dUMxa1",
  "Ow": "ChatSkeleton.module__identityBack___dUMxa1",
  "um": "ChatSkeleton.module__identityBackDesktop___dUMxa1",
  "W": "ChatSkeleton.module__identityName___dUMxa1",
  "aL": "ChatSkeleton.module__identityCaret___dUMxa1",
  "lf": "ChatSkeleton.module__identityTopicDivider___dUMxa1",
  "$s": "ChatSkeleton.module__headerActions___dUMxa1",
  "QE": "ChatSkeleton.module__headerAction___dUMxa1",
  "YB": "ChatSkeleton.module__headerSearch___dUMxa1",
  "lQ": "ChatSkeleton.module__headerSearchIcon___dUMxa1",
  "Qs": "ChatSkeleton.module__content___dUMxa1",
  "ec": "ChatSkeleton.module__memberListDivider___dUMxa1",
  "oM": "ChatSkeleton.module__chatArea___dUMxa1",
  "JX": "ChatSkeleton.module__chatBody___dUMxa1",
  "DZ": "ChatSkeleton.module__messages___dUMxa1",
  "T_": "ChatSkeleton.module__composerInputLine___dUMxa1",
  "PN": "ChatSkeleton.module__composerAction___dUMxa1",
  "JD": "ChatSkeleton.module__memberList___dUMxa1",
  "Pz": "ChatSkeleton.module__memberListScroller___dUMxa1",
};

module.exports = exports;
